<template>
  <v-dialog :value="shown" @input="onClose" max-width="400px">
    <v-card>
      <v-card-title class="headline">
        About Yield.IO
      </v-card-title>
      <v-card-text>
        <p>
          Yield.IO collects bond data from the US Treasury website and creates a dashboard of common
          charts based on historical bond yields.
        </p>
        <p>
          The Treasury calculates yields for
          common outstanding bond durations daily after the close of the bond market.
        </p>
        <p>
          Yield.IO updates a <a href="https://twitter.com/yieldio">Twitter feed</a> when new yields
          are available.
        </p>
        <p>
          The application uses Vue.js, Bootstrap, Chartjs, and AWS Lambda.
          The code is available <a href="https://gitlab.com/baus/yieldio">on GitLab</a>.
        </p>
        <p>
          &copy; 2017-2020 Christopher Baus &lt;christopher@baus.net&gt;
        </p>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          Depressed
          @click="onClose"
        >
          Close
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  export default {
    props: {
      shown: {
        required: true
      }
    },
    watch: {
      shown(value) {
        console.log('shown: ', value);
      }
    },
    methods: {
      onClose() {
        console.log('close');
        this.$emit('close');
      }
    }
  }
</script>

